/**
 * InstructionsPage: client-side zoekfilter + video afspelen in een Foundation
 * Reveal-popup. Losse bundle, alleen op deze pagina ingeladen
 * (zie InstructionsPageController::init()). Gebruikt de globale window.jQuery die
 * app.js registreert (met Foundation), zodat de Reveal-popup identiek werkt als
 * elders op de site.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-instructions]');
    if (!root) {
      return;
    }

    // --- Zoekfilter (titel + omschrijving + zoekwoorden, meerdere woorden) ---
    var input = root.querySelector('[data-search-input]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var empty = root.querySelector('[data-empty]');
    var count = root.querySelector('[data-count]');

    var haystacks = cards.map(function (card) {
      return (
        (card.getAttribute('data-title') || '') + ' ' +
        (card.getAttribute('data-desc') || '') + ' ' +
        (card.getAttribute('data-keywords') || '')
      ).toLowerCase();
    });

    function updateCount(visible) {
      if (!count) {
        return;
      }
      count.textContent = visible === 1 ? '1 video' : visible + " video's";
    }

    function filter() {
      var q = (input ? input.value : '').trim().toLowerCase();
      var tokens = q.length ? q.split(/\s+/) : [];
      var visible = 0;
      cards.forEach(function (card, i) {
        var match = tokens.every(function (t) {
          return haystacks[i].indexOf(t) !== -1;
        });
        card.classList.toggle('is-hidden', !match);
        if (match) {
          visible++;
        }
      });
      if (empty) {
        empty.hidden = visible !== 0;
      }
      updateCount(visible);
    }

    if (input) {
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(filter, 120);
      });
    }
    updateCount(cards.length);

    // --- Video in Reveal-popup ---
    var $ = window.jQuery;
    var modalEl = document.getElementById('instruction-video-modal');
    var frame = modalEl ? modalEl.querySelector('[data-instruction-frame]') : null;
    if (!$ || !modalEl || !frame) {
      return;
    }

    function openVideo(ytid, title) {
      if (!ytid) {
        return;
      }
      var src = 'https://www.youtube-nocookie.com/embed/' + ytid + '?autoplay=1&rel=0';
      frame.innerHTML = '<iframe src="' + src + '" title="' +
        String(title || '').replace(/"/g, '&quot;') +
        '" frameborder="0" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
      $(modalEl).foundation('open');
    }

    cards.forEach(function (card) {
      var trigger = card.querySelector('.instructions__video');
      if (!trigger) {
        return;
      }
      var open = function () {
        openVideo(trigger.getAttribute('data-ytid'), card.getAttribute('data-title'));
      };
      trigger.addEventListener('click', open);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });
    });

    // Stop de video zodra de popup sluit (leeg de iframe).
    $(modalEl).on('closed.zf.reveal', function () {
      frame.innerHTML = '';
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
